import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import { useHoverStyles } from '../ResoursesStatus';
import MyIcon from '../../../components/MyIcon';

function IconBox({ title, path, icon, color, height }: any) {
  const navigate = useNavigate();
  const classes = useHoverStyles();

  return (
    <Box style={{ height }}>
      <Box
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          onClick={() => navigate(path)}
          className={classes.button}
          style={{
            overflow: 'hidden',
            objectFit: 'cover',
            cursor: 'pointer',
            borderRadius: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 280,
            height: 280,
          }}
        >
          <MyIcon size={120} color={color} icon={icon}></MyIcon>
        </Box>

        <Box
          style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            style={{
              fontSize: 24,
              fontWeight: 'bold',
              marginTop: 5,
              marginBottom: 30,
            }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default IconBox;
